import(/* webpackMode: "eager" */ "/workspace/src/frontend/src/app/[locale]/onboarding/page.tsx");
